import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultScheduleService } from 'app/core/services/default-schedule.service';
import { RefreshDefaultscheduleService } from 'app/core/services/refresh-defaultschedule/refresh-defaultschedule.service';

@Component({
  selector: 'dialog-delete-defaultschedule',
  templateUrl: './dialog-delete-defaultschedule.component.html',
  styleUrls: ['./dialog-delete-defaultschedule.component.scss']
})
export class DialogDeleteDefaultscheduleComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteDefaultscheduleComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private defaultScheduleService: DefaultScheduleService, private refreshDefaultSchedule: RefreshDefaultscheduleService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteElement() {
    this.isLoading = true;
    this.defaultScheduleService.deleteDefaultSchedule(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.refreshDefaultSchedule.emitRefresh(this.data.index);
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }

}
